<template>
  <div>
    <div class="bj dis-cent">
      <div class="content">
        <div class="headBox">
          <div class="name">期望人才</div>
          <div class="iconfont icon-close close" @click="delClick"></div>
        </div>
        <div class="selCont">
          <div class="name">性格</div>
          <div class="inpBox">
            <input type="text" placeholder="请输入期望人才的性格" v-model="text" />
          </div>
        </div>
        <div class="selCont">
          <div class="name">婚姻状况</div>
          <div class="inpBox">
            <input type="text" placeholder="请输入期望人才的婚姻状况" v-model="text" />
          </div>
        </div>
        <div class="textBox">
          <div class="text">亮点作用：</div>
          <div class="text">1.可以更加精准的推荐适合人才</div>
        </div>
        <div class="btnBox">
          <div class="btn dis-cent" @click="saveClick">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
} from "ant-design-vue";
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
  },
  name: "",
  data() {
    return {
      value: undefined,
      list: [],
      text: "",
    };
  },
  created() {},
  methods: {
    saveClick() {
      this.$emit("show", this.text);
    },
    delClick() {
      this.$emit("show");
    },
    handleChange(value) {
      let on;
      for (let i = 0; i < this.qMoney.length; i++) {
        const e = this.qMoney[i];
        if (e.name == value) {
          on = i;
        }
      }
      this.qMoneyOn = on + 1;
      const newArray = this.removeElementsBeforeIndex(
        this.qMoney.slice(),
        on + 1
      );
      this.hMoney = newArray;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.bj {
  .content {
    background-color: #fff;
    border-radius: 10px;
    width: 600px;
    padding: 20px;
    .headBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        font-weight: 600;
        font-size: 18px;
      }
      .close {
        cursor: pointer;
      }
    }
    .selCont {
      display: flex;
      align-items: center;
      margin-top: 20px;
      .name {
        width: 70px;
      }
      .inpBox {
        width: calc(100% - 70px);
        height: 40px;
        border-radius: 5px;
        border: 1px solid #ebebeb;
        padding-left: 15px;
        input {
          width: 100%;
          height: 100%;
        }
      }
    }
    .textBox {
      padding-top: 40px;
      color: #4f6d92;
      .text {
        margin-top: 5px;
      }
    }
    .btnBox {
      margin-top: 80px;
      display: flex;
      justify-content: flex-end;
      .btn {
        width: 100px;
        background-color: #1277f3;
        height: 40px;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
}
</style>
